module.exports = __webpack_public_path__ + "img/0.8b61b6d1.jpg";